import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/AppShell";
import RequireAuth from "@/components/RequireAuth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Characters from "@/pages/Characters";
import Family from "@/pages/Family";
import CreateVideo from "@/pages/CreateVideo";
import Library from "@/pages/Library";
import Settings from "@/pages/Settings";
import Series from "@/pages/Series";
import SeriesNew from "@/pages/SeriesNew";
import SeriesDetail from "@/pages/SeriesDetail";
import Presets from "@/pages/Presets";
import Schedule from "@/pages/Schedule";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Everything else — auth required */}
          <Route element={<RequireAuth><AppShell /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="/create" element={<CreateVideo />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/family" element={<Family />} />
            <Route path="/library" element={<Library />} />
            <Route path="/series" element={<Series />} />
            <Route path="/series/new" element={<SeriesNew />} />
            <Route path="/series/:id" element={<SeriesDetail />} />
            <Route path="/presets" element={<Presets />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
